export const FETCH_SUPPLIER_REQUEST = "FETCH_SUPPLIER_REQUEST";
export const FETCH_SUPPLIER_SUCCESS = "FETCH_SUPPLIER_SUCCESS";
export const FETCH_SUPPLIER_FAIL = "FETCH_SUPPLIER_FAIL";

export const SUPPLIER_ADD_REQUEST = "SUPPLIER_ADD_REQUEST";
export const SUPPLIER_ADD_SUCCESS = "SUPPLIER_ADD_SUCCESS";
export const SUPPLIER_ADD_FAIL = "SUPPLIER_ADD_FAIL";

export const SUPPLIER_UPDATE_REQUEST = "SUPPLIER_UPDATE_REQUEST";
export const SUPPLIER_UPDATE_SUCCESS = "SUPPLIER_UPDATE_SUCCESS";
export const SUPPLIER_UPDATE_FAIL = "SUPPLIER_UPDATE_FAIL";

export const FETCH_BY_ID_SUPPLIER_REQUEST = "FETCH_BY_ID_SUPPLIER_REQUEST";
export const FETCH_BY_ID_SUPPLIER_SUCCESS = "FETCH_BY_ID_SUPPLIER_SUCCESS";
export const FETCH_BY_ID_SUPPLIER_FAIL = "FETCH_BY_ID_SUPPLIER_FAIL";
